import 'whatwg-fetch';
import Help from '../HtmlHelpers';
const queryString = require('query-string');
const Api = {};
Api.hostLocalStorageKey = () => "apiHost-".concat(process.env.REACT_APP_TITLE_ENV);
Api.clearApiHost = () => localStorage.removeItem(Api.hostLocalStorageKey());
Api.hostFromParams = () => {
  const paramsString = window.location.search;
  const urlParams = new URLSearchParams(paramsString);
  const apihost = urlParams.get('apiHost');
  if (apihost) {
    localStorage.setItem(Api.hostLocalStorageKey(), apihost);
  }
};
Api.localStorageHost = () => localStorage.getItem(Api.hostLocalStorageKey());
Api.hostFromParams();
const contractoApiHost = Api.localStorageHost() || process.env.REACT_APP_CONTRACTO_API_URL;
Api.crudCreate = function (authToken, type, data) {
  let version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return Api.doPost(authToken, "".concat(contractoApiHost, "/v").concat(version, "/").concat(type), JSON.stringify(data));
};
Api.crudDelete = function (authToken, type, data) {
  let version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return Api.doDelete(authToken, "".concat(contractoApiHost, "/v").concat(version, "/").concat(type, "/").concat(data.uuid), JSON.stringify(data));
};
Api.crudList = function (authToken, type) {
  let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return Api.doGet(authToken, "".concat(contractoApiHost, "/v").concat(version, "/").concat(type), params);
};
Api.crudUpdate = function (authToken, type, data) {
  let version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return Api.doPut(authToken, "".concat(contractoApiHost, "/v").concat(version, "/").concat(type, "/").concat(data.uuid), JSON.stringify(data));
};
Api.crudView = function (authToken, type, uuid) {
  let version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return Api.doGet(authToken, "".concat(contractoApiHost, "/v").concat(version, "/").concat(type, "/").concat(uuid));
};
Api.getUserGroups = authToken => Api.doGet(authToken, "".concat(contractoApiHost, "/v1/admin/user_groups"));
Api.userList = authToken => Api.doGet(authToken, "".concat(contractoApiHost, "/v1/admin/users"), {
  order: 'name'
});
Api.doGet = function (authToken, url) {
  let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return new Promise(resolve => {
    let newUrl = url;
    if (params !== null) {
      newUrl += newUrl.indexOf('?') > -1 ? '&' : '?';
      newUrl += queryString.stringify(params);
    }
    resolve(Api.doRequest('GET', newUrl, body, authToken));
  });
};
Api.doPut = function (authToken, url) {
  let body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return Api.doRequest('PUT', url, body, authToken);
};
Api.doPost = function (authToken, url) {
  let body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return Api.doRequest('POST', url, body, authToken);
};
Api.doDelete = function (authToken, url) {
  let body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return Api.doRequest('DELETE', url, body, authToken);
};
Api.doRequest = async (type, url, body, auth) => {
  const authToken = await Api.getAuthToken(auth);
  return fetch(url, {
    method: type,
    body,
    headers: {
      Authorization: authToken
    }
  }).then(Api.checkStatus).then(response => response.json()).catch(error => error);
};
Api.checkStatus = response => {
  if (response.status === 500) {
    throw response.statusText;
  } else {
    return response;
  }
};
Api.doPdfRequest = async (type, url, filename, auth) => {
  const authToken = await Api.getAuthToken(auth);
  return fetch(url, {
    method: type,
    headers: {
      Authorization: authToken
    }
  }).then(response => response.blob()).then(blob => {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([blob], {
      type: 'application/pdf'
    }));
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  });
};
Api.downloadFile = async (type, url, filename, auth) => {
  const authToken = await Api.getAuthToken(auth);
  return fetch(url, {
    method: type,
    headers: {
      Authorization: authToken
    }
  }).then(response => response.blob()).then(blob => {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  });
};
Api.getAuthToken = async auth => {
  if ((auth === null || auth === void 0 ? void 0 : auth.auth_type) === 'auth0') {
    if (!auth.isAuthenticated) {
      Api.reloadExpiredPage(true);
    }
    let authToken = await auth.getIdTokenClaims();
    return authToken.__raw;
  } else {
    const info = JSON.parse(localStorage.getItem('okta-token-storage'));
    const client = Help.dig([info, 'idToken', 'clientId']);
    const desiredClient = process.env.REACT_APP_OKTA_CLIENT_ID;
    if (client !== desiredClient) {
      localStorage.removeItem('okta-token-storage');
      localStorage.removeItem('okta-cache-storage');
      Api.reloadExpiredPage(false);
    } else if (!(await auth.isAuthenticated())) {
      Api.reloadExpiredPage(true);
    }
    return auth.getIdToken();
  }
};
Api.reloadExpiredPage = showMessage => {
  let url = window.location.href;
  if (showMessage) {
    url += url.indexOf('?') > -1 ? '&' : '?';
    url += 'expired=Y';
  }
  window.location.href = url;
};
export default Api;